import ErrorPage from "@shared/pages/ErrorPage";

export const makeRoute = (
  path: string,
  element: React.ReactNode,
  layout: React.ReactNode
) => ({
  path,
  element: layout,
  errorElement: <ErrorPage />,
  children: [
    {
      index: true,
      element,
    },
  ],
});

export default makeRoute;
